'use strict';

import React, { Component, Fragment } from 'react';
import SelectV2 from 'Components/Forms/Elements/SelectV2';
import Loader from 'Pure/Loader';
import getErrorsFromResponse from 'Components/Forms/Functions/getErrorsFromResponse';
import { action, URL } from 'Shared/Routes';
const {
  app,
  qwest
} = window;
export default class EtablishmentSelection extends Component {
  state = {
    loading: false,
    already_open: false,
    etablishment_id: app.state.session?.user?._etablishment?.id
  };
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    app.push({
      event: 'sessionChange',
      cb: component.handleSessionChange
    });
    component.handleSessionChange({
      source: 'DidMount'
    });
    component.fetchEtablishments();
  }
  componentWillUnmount() {
    const component = this,
      props = this.props,
      state = this.state;
    app.delete({
      event: 'sessionChange',
      cb: component.handleSessionChange
    });
  }
  componentDidUpdate(prev_props, prev_state) {
    const component = this,
      props = this.props,
      state = this.state;
    const select_ref = component.select_ref;
    const opened = prev_props.visible !== true && props.visible === true;
    const closed = prev_props.visible === true && props.visible === false;
    if (opened && state.already_open === false) {
      component.setState({
        already_open: true
      });
    }
    if (!select_ref) return;
    if (opened) {
      select_ref?.focus();
    } else if (closed) {
      select_ref?.blur();
    }
  }
  handleSessionChange = ({
    source,
    data
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    if (!app.state.session?.user?.id) return;
    component.setState({
      etablishment_id: app.state.session?.user?._etablishment?.id
    });
  };
  fetchEtablishments = () => {
    const component = this,
      props = this.props,
      state = this.state;
    qwest.post(action('getEtablishmentsForAdminSelection')).then(function (xhr, response) {
      component.setState({
        options: response.etablishments.sort(function (a, b) {
          const name_a = a.name || '';
          const name_b = b.name || '';
          return name_a.toLowerCase().localeCompare(name_b.toLowerCase());
        }).map(function (data) {
          let option = {
            value: data.id,
            label: data.name
          };
          return option;
        }),
        loading: false
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        })
      });
    });
  };
  changeHotel = ({
    e,
    name,
    value
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    if (!value) return;
    component.setState({
      hotel: value,
      loading: true
    });
    qwest.post(action('switchEtablishment'), {
      id: value
    }).then(function (xhr, response) {
      let pathname = document.location.pathname;
      if (pathname.endsWith('/')) pathname = pathname.slice(0, -1);
      const is__establishment_form_page = pathname.startsWith(URL('UpdateEtablishmentPage').replace(':id', ''));
      const is__space_form_page = pathname.startsWith(URL('AdminCoworkingSpacesDashboard') + '/');
      if (is__establishment_form_page) {
        const user_establishment = app.state.session.user?._etablishment?.id;
        const user_establishment_page = URL('UpdateEtablishmentPage').replace(':id', user_establishment);
        if (pathname === user_establishment_page) {
          document.location.pathname = user_establishment_page.replace(user_establishment, value);
        } else {
          window.location.reload();
        }
      } else if (is__space_form_page) {
        window.location.pathname = URL('AdminCoworkingSpacesDashboard');
      } else {
        window.location.reload();
      }
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        })
      });
    });
  };
  captureClick = e => {
    const component = this,
      props = this.props,
      state = this.state;
    e.stopPropagation();
    app.emit({
      event: 'documentClick',
      source: 'AdminHotelSelection'
    });
  };
  setRef = ref => {
    const component = this,
      props = this.props,
      state = this.state;
    component.select_ref = ref;
  };
  handleKeyDown = e => {
    const component = this,
      props = this.props,
      state = this.state;
    if (e.keyCode === 27 && props.visible === true)
      // escape key
      {
        props.close();
      }
  };
  onBGClick = e => {
    const component = this,
      props = this.props,
      state = this.state;
    e.stopPropagation();
    props.close();
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    if (!state.options || !state.etablishment_id || !state.already_open) {
      return /*#__PURE__*/React.createElement("div", {
        className: "o-header__hotel-selection"
      });
    }
    const loader = state.loading === true ? /*#__PURE__*/React.createElement(Loader, {
      className: "c-loader",
      bemit: ['primary', 'bg-white']
    }) : undefined;
    let output = /*#__PURE__*/React.createElement("div", {
      className: "o-header__hotel-selection-container",
      onClick: component.captureClick
    }, /*#__PURE__*/React.createElement("div", {
      className: 'o-header__hotel-selection' + (props.visible ? ' is-visible' : ''),
      onClick: component.captureClick
    }, /*#__PURE__*/React.createElement("div", {
      className: "o-header__hotel-info-title"
    }, "Changement d'\xE9tablissement actif"), /*#__PURE__*/React.createElement(SelectV2, {
      value: state.hotel,
      options: state.options,
      name: "header-hotel-switcher",
      className: "o-header__hotel-switcher",
      onChange: component.changeHotel,
      placeholder: " Rechercher...",
      onRef: component.setRef,
      onKeyDown: component.handleKeyDown,
      autoFocus: true
    }), loader), /*#__PURE__*/React.createElement("div", {
      className: 'o-header__hotel-selection__bg' + (props.visible ? ' is-visible' : ''),
      onMouseDown: component.onBGClick
    }));
    return output;
  }
}
